import React from 'react';

import {
  MessageType,
  NoEntitiesMessage,
} from 'client/app/apps/experiments/NoEntitiesMessage';

type Props = {
  searchQuery?: string;
};

const EmptyProtocolInstanceList = ({ searchQuery }: Props) => {
  return (
    <NoEntitiesMessage
      entityName="protocol runs"
      messageType={MessageType.NO_FILTER_RESULTS}
      searchQuery={searchQuery}
    />
  );
};

export default EmptyProtocolInstanceList;
